const ACTION_SCOPE = '[Cart]';

export namespace CartActions {
  export class Get {
    static readonly type = `${ACTION_SCOPE} Get`;
    constructor(public list: any) {}
  }
  export class Set {
    static readonly type = `${ACTION_SCOPE} Set`;
    constructor(public item: any) {}
  }

  export class SetShipping {
    static readonly type = `${ACTION_SCOPE} Set Shipping`;
    constructor(public item: number) {}
  }
  export class SetTokenStripe {
    static readonly type = `${ACTION_SCOPE} Set Token Stripe`;
    constructor(public item: string) {}
  }
  export class Update {
    static readonly type = `${ACTION_SCOPE} Update`;
    constructor(public item: any) {}
  }
  export class Delete {
    static readonly type = `${ACTION_SCOPE} Delete`;
    constructor(public item: string) {}
  }
  export class Reset {
    static readonly type = `${ACTION_SCOPE} Reset`;
  }
}
